module.exports = __webpack_public_path__ + "img/Bill Holtzclaw.17ab7406.jpg";